<template>
  <div v-show="products?.length || loading">
    <div v-if="title || hasArrows" class="mb-4 flex items-center" :class="[titleClass, title ? 'between' : 'justify-end']">
      <h2 v-if="title" v-style:c="titleColor" :class="titleStyle">
        <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
        <span v-else>{{ title }}</span>
      </h2>
      <vf-carousel-controls v-if="hasArrows" :carousel-ref :variant="backgroundType" />
    </div>
    <vf-carousel-elevate
      ref="carouselRef"
      align="start"
      :bleed="edgeToEdge"
      class-container="lg:-mr-1"
      :show-arrows="false"
      :show-pagination="!hasArrows"
      :slides-to-scroll="!$viewport.md ? 'auto' : (variant === '6-cards' ? 6 : 3)"
    >
      <template v-if="!products?.length">
        <div
          v-for="i in 6"
          :key="i"
          v-style:w="variantStyleMap[variant]"
          :aria-label="replaceAll($t.slideOf, { current: i, total: products.length })"
          class="pr-1 children:skeleton"
          role="tabpanel"
        >
          <div style="aspect-ratio: 0.72" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(product, i) in products"
          :key="product.id"
          v-style:w="variantStyleMap[variant]"
          :aria-label="replaceAll($t.slideOf, { current: i + 1, total: products.length })"
          class="pr-1"
          role="tabpanel"
        >
          <product-card-recommended
            :currency
            v-bind="product"
            :gtm-config="{ placement, title }"
            :quickshop
            :variant
            @product-click="$emit('product-click', product, i + 1)"
          />
        </div>
      </template>
      <template #pagination="{ activeItem, total, scrollTo }">
        <vf-carousel-pagination-dots
          v-if="carouselRef?.canScroll"
          :active="activeItem"
          class="mt-2 justify-center"
          :total
          :variant="backgroundType"
          @update:active="scrollTo($event)"
        />
      </template>
    </vf-carousel-elevate>
  </div>
</template>

<script lang="ts" setup>
import type { Props } from '#types/components/cms/recommendation-carousel'
import { getPageInfo } from '#commerce/gtm/page'

const {
  backgroundType,
  currency,
  edgeToEdge,
  navigationType = 'dots',
  products,
  quickshop = true,
  title,
  titleClass,
  titleStyle = 'title-3',
  variant = '6-cards',
} = defineProps<Props>()

defineEmits<{
  'product-click': [product: any, position: number]
}>()

const { variantStyleMap } = useAppConfig().components.cms.bloomreachRecommendations

const route = useRoute()
const carouselRef = ref()
const [placement] = variant === 'search-hub' ? [extractPageType('/searchhub')] : getPageInfo(route, {})
const hasArrows = navigationType === 'arrows'
</script>
